(function documentTypeAssociateMetadataControllerDefinition() {
    'use strict';

    angular.module('DocumentType')
        .controller('DocumentTypeAssociateMetadataController', [
            '$scope', 'config', '$state', '$translate', '$stateParams', '$uibModal', '$q', 'errorsExtend', 'adminDocumentTypeService',
            'adminMetadataService', 'authExtend', 'alerts',
            function documentTypeAssociateMetadataController($scope, config, $state, $translate, $stateParams, $modal, $q, errors, adminDocumentTypeService, adminMetadataService, auth, alerts) {

                $scope.models = {
                    selected: null,
                    source: null,
                    associated: [],
                    disabled: [],
                    availables: [],
                    nameTemplate: undefined
                };

                adminDocumentTypeService.getById($stateParams.id, 'Put').then(function (result) {
                    $scope.documentType = result;
                    $scope.models.associated = result.metadata;
                    $scope.models.disabled = result.disabledMetadata;
                    $scope.models.nameTemplate = $scope.documentType.nameTemplate;
                }, function (error) {
                    errors.showError(error);
                    $state.go('document-type-find');
                }).then(function () {
                    adminMetadataService.getNotInDocumentType($stateParams.id).then(function (result) {
                        $scope.models.availables = result;
                    });
                });


                $scope.moveFromAssociated = function (item, index) {
                    $scope.models.associated.splice(index, 1);
                    if (item.isNew) {
                        $scope.models.availables.splice(item.previousIndex, 0, item);
                    }
                    else {
                        $scope.models.disabled.push(item);
                    }
                }

                $scope.moveFromDisabledRight = function (item, index) {
                    $scope.models.disabled.splice(index, 1);
                    if (item.previousIndex != undefined) {
                        $scope.models.availables.splice(item.previousIndex, 0, item);
                    }
                    else {
                        $scope.models.availables.push(item);
                    }
                }

                $scope.moveFromDisabledLeft = function (item, index) {
                    $scope.models.disabled.splice(index, 1);
                    $scope.models.associated.push(item);
                    return $scope.postProcess(item, $scope.models.associated.length - 1);
                }

                $scope.moveFromAvailable = function (item, index) {
                    item.isNew = true;
                    item.previousIndex = index;
                    $scope.models.availables.splice(index, 1);
                    $scope.models.associated.push(item);
                    return $scope.postProcess(item, $scope.models.associated.indexOf(item));
                }

                $scope.validateAction = function (event, index, item) {
                    if (item.fromTemplate) {
                        return false;
                    }

                    var currentSource = $scope.models.source;
                    var currentTarget = event.target.parentElement.attributes['dnd-list'].value;
                    $scope.models.source = null;

                    if (!$scope.documentType.hasAssociatedDocument || item.isNew) {
                        if (currentTarget === 'models.associated') {
                            if (currentSource === 'models.availables') {
                                item.previousIndex = $scope.getIndex(item, $scope.models.availables);
                                item.isNew = true;
                            }
                            return $scope.postProcess(item, index);
                        } else {
                            return item;
                        }
                    }

                    if (currentTarget === 'models.availables') {
                        return false;
                    }

                    if (currentSource === 'models.availables') {
                        item.previousIndex = $scope.getIndex(item, $scope.models.availables);
                        item.isNew = true;
                    }

                    if (currentTarget === 'models.associated') {
                        return $scope.postProcess(item, index);
                    }

                    return item;
                };


                $scope.getIndex = function (item, list) {
                    for (var i = 0; list.length > i; i++) {
                        if (item.metadataId === list[i].metadataId)
                            return i;
                    }

                    return -1;
                }

                $scope.removeItem = function (source, index) {
                    source.splice(index, 1);
                };

                $scope.setSource = function (event) {
                    $scope.models.source = event.target.parentElement.attributes['dnd-list'].value;
                };
                $scope.cancel = function () {
                    $state.go('document-type-find');
                };

                $scope.save = function (apply) {
                    for (var index = 0; index < $scope.models.associated.length; index++) {
                        $scope.models.associated[index].position = index;
                    }

                    if (!apply) {
                        return adminDocumentTypeService.modify($scope.documentType).then(function () {
                            $state.go('document-type-find', { name: $scope.documentType.name });
                        },
                            function (error) {
                                errors.showError(error);
                            });
                    }

                    $translate(['TouchDocumentsConfirm', 'TouchDocumentsConfirmText', 'Yes', 'No']).then(function (translated) {
                        return alerts.confirm(translated.TouchDocumentsConfirm, translated.TouchDocumentsConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                            if (!result) {
                                return;
                            }

                            adminDocumentTypeService.modify($scope.documentType)
                                .then(function () {
                                    return adminDocumentTypeService.touchDocuments($scope.documentType.id).then(function () {
                                        $state.go('document-type-find', { name: $scope.documentType.name });
                                    }, function (error) {
                                        errors.showError(error);
                                        $state.go('document-type-find', { name: $scope.documentType.name });
                                    });

                                }, function (error) {
                                    errors.showError(error);
                                });
                        });
                    });
                };

                function setValue(scope, property, value) {
                    if (value) {
                        $q.when(value).then(function (val) {
                            scope[property] = val;
                        });
                    }
                }

                var modalController = function ($scope, $modalInstance, $translate, info) {
                    setValue($scope, 'title', info.name);
                    $scope.item = info;
                    $scope.metadataTypeValidation = info.metadataType === 'text' || info.metadataType === 'number';
                    $scope.showAsName = true;

                    if (!$scope.item.asName) {
                        for (var i = 0; i < $scope.item.associated.length; i++) {
                            if ($scope.item.associated[i].asName) {
                                $scope.showAsName = false;
                                break;
                            }
                        }
                    }

                    $scope.setRequired = function () {
                        $scope.item.required = "1";
                    }

                    $scope.checkRequirityChange = function () {
                        //if ($scope.item.isIdentifier == "1") {
                        //    $scope.item.required = "1";
                        //}
                    }

                    $scope.unSetAsMetadata = function () {
                        $scope.item.asName = "0";
                    }

                    $scope.setCalendar = function () {
                        $scope.item.searchCriteria = "1";
                    }

                    $scope.unSetCalendar = function () {
                        $scope.item.calendar = "0";
                    }

                    $scope.onResultCriteriaChange = function (item) {
                        if (item.resultCriteria == "0") {
                            item.isSortable = "0";
                        }
                    }

                    $scope.ok = function () {
                        if ($scope.metadataForm.$valid) {

                            for (var i = 0; i < $scope.item.associated.length; i++) {
                                if ($scope.item.associated[i].useCalendar && $scope.item.associated[i].metadataSystemName !== $scope.item.systemName) {
                                    $scope.item.associated[i].useCalendar = false;
                                    break;
                                }
                            }

                            $modalInstance.close($scope.item);
                        } else {
                            errors.showError('VerifyFormData');
                        }
                    };
                };
                modalController.$inject = ['$scope', '$modalInstance', '$translate', 'info'];

                function openModal(item, associated, countSortableMetadatas) {
                    var modalInstance = $modal.open({
                        templateUrl: '/app/views/document-type/partial-metadata-association.html',
                        controller: modalController,
                        size: 'md',
                        resolve: {
                            info: function () {
                                return {
                                    name: item.metadataLabel,
                                    systemName: item.metadataSystemName,
                                    required: item.isRequired,
                                    unique: item.isUnique,
                                    searchCriteria: item.isSearchCriteria,
                                    resultCriteria: item.isResultCriteria,
                                    isIdentifier: item.isIdentifier,
                                    fromBarcode: item.fromBarcode,
                                    fromBarcodeStart: item.fromBarcodeStart,
                                    fromBarcodeLength: item.fromBarcodeLength,
                                    calendar: item.useCalendar,
                                    metadataType: item.metadataType,
                                    asName: item.asName,
                                    associated: associated,
                                    isMultivalue: item.isMultivalue,
                                    isSortable: item.isSortable,
                                    mask: item.mask === '' ? item.metadataMask : item.mask,
                                    label: item.label === '' ? item.metadataLabel : item.label,
                                    metadataType: item.metadataType,
                                    canSortMetadata: (countSortableMetadatas < config.maxSorteableMetadatas() || item.isSortable)
                                };
                            }
                        }
                    });

                    var result = modalInstance.result;
                    return result;
                }

                $scope.postProcess = function (item, index) {
                    var oldIndex = $scope.getIndex(item, $scope.models.associated);
                    if (oldIndex >= 0 && index > oldIndex) {
                        //le saco una pos, porque cuenta su viejo registro.
                        index--;
                    }

                    var countSortableMetadatas = $scope.documentType.metadata.filter(function (x) { return x.isSortable == true }).length;
                    openModal(item, $scope.models.associated, countSortableMetadatas).then(function (result) {
                        var currentItem = $scope.models.associated[index];
                        currentItem.isRequired = result.required === true || result.required === '1';
                        currentItem.isUnique = result.unique === true || result.unique === '1';
                        currentItem.isSearchCriteria = result.searchCriteria === true || result.searchCriteria === '1';
                        currentItem.isResultCriteria = result.resultCriteria === true || result.resultCriteria === '1';
                        currentItem.isIdentifier = result.isIdentifier === true || result.isIdentifier === '1';
                        currentItem.isSortable = result.isSortable === true || result.isSortable === '1';
                        currentItem.fromBarcode = result.fromBarcode === true || result.fromBarcode === '1';
                        currentItem.asName = result.asName === true || result.asName === '1';
                        if (currentItem.fromBarcode) {
                            currentItem.fromBarcodeStart = result.fromBarcodeStart;
                            currentItem.fromBarcodeLength = result.fromBarcodeLength;
                        }
                        currentItem.mask = result.mask;
                        currentItem.label = result.label;
                        currentItem.useCalendar = result.calendar === true || result.calendar === '1';
                        currentItem.documentTypeId = $stateParams.id;
                        if (currentItem.id === 0) {
                            currentItem.id = null;
                        }
                    });

                    return item;
                };
            }
        ]);
})();